import { createI18n } from 'vue-i18n'
import nl from './nl'
import en from './en'

const savedLocale = localStorage.getItem('lang') || 'nl'

export default createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'nl',
  messages: { nl, en },
})
